export const HEIGHT_OF_TIMEGRID_CELL_IN_REM = 0.6 // 1.5
export const HEIGHT_OF_TIMEGRID_CELL_IN_REM_MOBILE = 0.5 // 1.5